// Guard against browser translators (Google Translate etc.) mutating the DOM
// out from under React. Workaround posted by @gaearon in
// https://github.com/facebook/react/issues/11538#issuecomment-417504600.
/* eslint-disable @typescript-eslint/unbound-method */
export function installBrowserTranslateGuard(): void {
  if (typeof Node !== "function") {
    return;
  }

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (this: Node, child: Node) {
    if (child.parentNode !== this) {
      return child;
    }
    return originalRemoveChild.call(this, child);
  } as Node["removeChild"];

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (
    this: Node,
    newNode: Node,
    referenceNode: Node | null,
  ) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return newNode;
    }
    return originalInsertBefore.call(this, newNode, referenceNode);
  } as Node["insertBefore"];
}
/* eslint-enable @typescript-eslint/unbound-method */
